import $ from 'jquery';

export function getData() {
  // return $.get('https://fnk-backend.herokuapp.com/rki-api');
  return $.get(ARTICLE_CONFIG.baseUrl+'/data/grippe/data.json');
}

export function getCurrentWeek() {
  const today = new Date();
  const onejan = new Date(today.getFullYear(), 0, 1);
  const millisecsInDay = 86400000;

  return 4;

  return Math.ceil((((today - onejan) / millisecsInDay) + onejan.getDay() + 1) / 7);
}

export function range(start, end) {
  return Array.from({length: (end - start)}, (v, k) => k + start);
}

// https://stackoverflow.com/questions/16590500/javascript-calculate-date-from-week-number
export function getDateOfISOWeek(w, y) {
  const simple = new Date(y, 0, 1 + (w - 1) * 7);
  const dow = simple.getDay();
  const ISOweekStart = simple;

  if (dow <= 4)
      ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
  else
      ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());

  return ISOweekStart;
}

export function formatDate(date) {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  return `${day}.${month}.${year}`;
}

export function getWeekRangeDates(startDate) {
  const weekStart = startDate;
  const weekEnd = new Date(+startDate).setDate(weekStart.getDate() + 6);

  return [formatDate(weekStart), formatDate(new Date(weekEnd))];
}